module.exports = __webpack_public_path__ + "media/images/betSponsor-82fb5cfbd049c8206faf583d43eb4a30.png";